import { Rocket } from 'lucide-react';
import { useLocation } from 'react-router-dom';

import { adminUiCopy } from '../i18n/adminUi';
import { useI18n } from '../i18n/provider';

export function EarlyAccessBanner(): JSX.Element | null {
  const location = useLocation();
  const { locale } = useI18n();
  const copy = adminUiCopy[locale].earlyAccessBanner;

  // Only show banner on the landing page
  if (location.pathname !== '/') {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 h-9 bg-slate-900 z-[60] flex items-center justify-center">
      <div className="flex items-center gap-2 sm:gap-3">
        <div className="flex items-center gap-1.5 sm:gap-2 text-white/90">
          <Rocket className="w-3.5 h-3.5 text-blue-400 flex-shrink-0" />
          <span className="font-medium text-[13px] sm:text-base">{copy.program}</span>
        </div>
        <a
          href="https://early-access.walletgate.app"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-blue-300 transition-colors duration-200 text-[13px] sm:text-base font-semibold whitespace-nowrap flex-shrink-0"
        >
          {copy.register} &rarr;
        </a>
      </div>
    </div>
  );
}
